import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, KeyValue } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FilterEditorComponent } from '../components/filter-editor/filter-editor.component';
import { FilterChip } from '../models/filter-chip';
import { BehaviorSubject, combineLatest, debounceTime, distinct, filter, firstValueFrom, map, of, shareReplay, startWith, Subject, Subscription } from 'rxjs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ConfirmComponent } from '../dialogs/confirm/confirm.component';
import { UsersService } from '../services/user.service';
import { User } from '../models/user';
import { UserEditorComponent } from '../components/dialogs/user-editor/user-editor.component';
import { GroupsService } from '../services/groups.service';
import { Group } from '../models/group';
import { GroupMembershipEditorComponent } from '../components/dialogs/group-membership-editor/group-membership-editor.component';
import { GroupMembersService } from '../services/group-members.service';
import { FilterChipUtilityService } from '../services/filter-chip-utility.service';
import { ProjectsService } from '../services/projects.service';
import { Project } from '../models/project';
import { ProjectMembersService } from '../services/project-members.service';
import { environment } from '../../environments/environment';
import { UIPreference, TableUIPreferences, UserManagementPreferences } from '../models/ui-preferences';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CdkDrag, CdkDragDrop, DragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { BatchAddRemoveFromUsersComponent } from '../dialogs/batch-add-remove-from-users/batch-add-remove-from-users.component';
import { Effort } from '../models/effort';
import { EffortsService } from '../services/efforts.service';
import { EffortOwnersService } from '../services/effort-owners.service';

@Component({
  selector: 'app-user-administration',
  templateUrl: './user-administration.component.html',
  styleUrls: ['./user-administration.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatExpansionModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatOptionModule,
    ReactiveFormsModule,
    MatSelectModule,
    FormsModule,
    MatButtonModule,
    MatPaginatorModule,
    MatSortModule,
    FilterEditorComponent,
    RouterModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    DragDropModule
  ],
})
export class UserAdministrationComponent implements OnInit {
  availableColumns = new Map(Object.entries({
    "username": "Hawk Id",
    "fullname": "Name",
    "univid": "University Id",
    "emp-number": "Employee Number",
    "email": "Email",
    "reportsto": "Reports To",
    "job-title": "Job Title",
    "job-code": "Job Code",
    "dept-code": "Dept Code",
    "subdept-code": "Subdept Code",
    "org-id": "Org Id",
    "pay-grade": "Pay Grade",

    'former-job-code': 'Former Job Code',
    "former-job-title": "Former Job Title",
    "former-dept-code": "Former Dept Code",
    "former-subdept-code": "Former Subdept Code",
    "former-org-id": "Former Org Id",
    "former-pay-grade": "Former Pay Grade",

    "pop-source": "AD Source",
    "leave": "Leave",
    "finalLeave": "Final Leave",
    "role": "Role",
    "created": "Created",
    "tks-begin-date": "TKS Begin Date",
    "last-updated": "Last Updated",
    "edit": "Edit"
  }));
  latestColumnOrder?: string[];
  originalOrder = (a: KeyValue<string,string>, b: KeyValue<string,string>): number => {
    return 0;
  }
  displayedColumns: string[] = 'username fullname univid email reportsto job-title dept-code leave role edit'.split(' ');
  readonly defaultColumns: string[] = [...this.displayedColumns];
  chosenColumns: FormControl = new FormControl([...this.displayedColumns]);
  dataSource = new MatTableDataSource<User>();
  filterControl = new FormControl('');
  selectedFilters: Subject<FilterChip[]> = new BehaviorSubject<FilterChip[]>([]);
  _loading = new BehaviorSubject<boolean>(false);
  isLoading = this._loading.pipe(debounceTime(environment.spinnerDelay));
  groupSubscription?: Subscription;
  projSubscription?: Subscription;
  effortSubscription?: Subscription;
  group?: Group;
  project?: Project;
  effort?: Effort;
  totalUsers: number = 0;
  currentUser?: User;
  uiPreference?: UIPreference;
  pageSubscr?: Subscription;
  chosenColSubscr?: Subscription;
  projectMembersSubscription?: Subscription;
  groupMembersSubscription?: Subscription;
  effortOwnersSubscription?: Subscription;
  querySubscription?: Subscription;
  queryParamsSubscription?: Subscription;
  canAdd: boolean = false;
  columnOrderChanges$ = new Subject<string[]>();
  columnOrderChanges = this.columnOrderChanges$.asObservable();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  subscription?: Subscription;
  colOrderSubscr?: Subscription;
  filters?: FilterChip[];
  private _dataChangedSubject = new Subject<FilterChip[]>();
  private dataChanged$ = this._dataChangedSubject.asObservable();
          //   [chips]="['name', 'email', 'hawkid', 'univid', 'dept', 'dept(owners)', 'dept.key', 'reportsto.hawkid', 'adsource', 'role',
          // 'jobtitle','jobcode', 'orgid', 'hrdept', 'hrsubdept', 'paygrade', 'effort.key',
          // 'former.jobtitle', 'former.jobcode', 'former.orgid', 'former.hrdept', 'former.hrsubdept', 'former.paygrade']"
          // [flags]="['archived', 'deprovisioned']" 
  readonly chipHelpers = {
      "name": "Filters by user's full name",
      "hawkid": "Filters by user's hawk id",
      "email": "Filters by user's email",
      "univid": "Filters by user's university id",
      "dept" : "Filters by departments the users are affiliated with, either as a member (via projects and efforts) or as an owner",
      "dept(owners)": "Filters by departments the users own",
      "dept.key": "Filters by departments the users own, strictly by key equality",
      "reportsto.hawkid": "Filters by the hawk id of the user that other users report to",
      "adsource": "Filters by which AD group the user is enrolled via",
      "role": "Filters by user role in the application",
      "jobtitle": "Filters by user's current job title",
      "jobcode": "Filters by user's current job code",
      "orgid": "Filters by user's current org id",
      "hrdept": "Filters by user's current HR department",
      "hrsubdept": "Filters by user's current HR sub-department",
      "paygrade": "Filters by user's current pay grade",
      "effort.key": "Filters by efforts the user is affiliated with, by effort key (exact)",
      "effort" : "Filters by efforts the user is affiliated with",
      "former.jobtitle": "Filters by user's former job title",
      "former.jobcode": "Filters by user's former job code",
      "former.orgid": "Filters by user's former org id",
      "former.hrdept": "Filters by user's former HR department",
      "former.hrsubdept": "Filters by user's former HR sub-department",
      "former.paygrade": "Filters by user's former pay grade",
      "deprovisioned": "(Flag) Filters by whether a user has been marked as deprovisioned (auto setting)",
      "archived": "(Flag) Filters by whether a user has been marked as archived (manual setting)",
  };
  readonly chipPossVals: { [key: string]: string[] | ((v: string) => Promise<string[] | string[][]>) } = {
      'dept': (value: string) =>
          firstValueFrom(this.deptService.filterGroups([{ chip: null, value }]).pipe(map((o => o.groups.map(u => [u.key, `${u.name} (${u.key})`]))))),
      'dept(owners)': (value: string) =>
          firstValueFrom(this.deptService.filterGroups([{ chip: "member", value }]).pipe(map((o => o.groups.map(u => [u.key, `${u.name} (${u.key})`]))))),
      'dept.key': (value: string) =>
          firstValueFrom(this.deptService.filterGroups([{ chip: "key", value }]).pipe(map((o => o.groups.map(u => u.key))))),
      'reportsto.hawkid': (value: string) =>
          firstValueFrom(this.usersService.filterUsers([{ chip: null, value }], 10, 0).pipe(map(o => o.users.map(u => [u.hawkId, `${u.displayName} (${u.hawkId})`])))),
      'effort.key': (value: string) =>
          firstValueFrom(this.effortService.filterEfforts([{ chip: "key", value }], 10, 0).pipe(map(o => o.efforts.map(e => [e.key, `${e.title} (${e.key})`])))),
      'effort': (value: string) =>
          firstValueFrom(this.effortService.filterEfforts([{ chip: null, value }], 10, 0).pipe(map(o => o.efforts.map(e => [e.key, `${e.title} (${e.key})`])))),
      'adsource': (value: string) =>
          firstValueFrom(this.usersService.getDistinctValuesForProperty("PopSource", value).pipe(map(vals => vals.map(v => [v, v ?? "[N/A - non-AD source]"])))),
      'hrdept': (value: string) =>
          firstValueFrom(this.usersService.getDistinctValuesForProperty("DepartmentCode", value).pipe(map(vals => vals.filter(v => v != null).map(v => [v, v])))),
      'hrsubdept': (value: string) =>
          firstValueFrom(this.usersService.getDistinctValuesForProperty("SubdeptCode", value).pipe(map(vals => vals.filter(v => v != null).map(v => [v, v ?? "[N/A]"])))),
      'paygrade': (value: string) => 
          firstValueFrom(this.usersService.getDistinctValuesForProperty("PayGrade", value).pipe(map(vals => vals.filter(v => v != null).map(v => [v, v ?? "[N/A]"])))),
      'jobcode': (value: string) =>
          firstValueFrom(this.usersService.getDistinctValuesForProperty("JobCode", value).pipe(map(vals => vals.filter(v => v != null).map(v => [v, v ?? "[N/A]"])))),
      'orgid': (value: string) =>
          firstValueFrom(this.usersService.getDistinctValuesForProperty("OrgId", value).pipe(map(vals => vals.filter(v => v != null).map(v => [v, v ?? "[N/A]"])))),

      'former.hrdept': (value: string) =>
          firstValueFrom(this.usersService.getDistinctValuesForProperty("FormerHRDept", value).pipe(map(vals => vals.filter(v => v != null).map(v => [v, v ?? "[N/A]"])))),
      "former.orgid": (value: string) =>
          firstValueFrom(this.usersService.getDistinctValuesForProperty("FormerOrgId", value).pipe(map(vals => vals.filter(v => v != null).map(v => [v, v ?? "[N/A]"])))),
      "former.jobcode": (value: string) =>
          firstValueFrom(this.usersService.getDistinctValuesForProperty("FormerJobCode", value).pipe(map(vals => vals.filter(v => v != null).map(v => [v, v ?? "[N/A]"])))),
      "former.paygrade": (value: string) =>
          firstValueFrom(this.usersService.getDistinctValuesForProperty("FormerPayGrade", value).pipe(map(vals => vals.filter(v => v != null).map(v => [v, v ?? "[N/A]"])))),
      "former.hrsubdept": (value: string) =>
          firstValueFrom(this.usersService.getDistinctValuesForProperty("FormerSubdeptCode", value).pipe(map(vals => vals.filter(v => v != null).map(v => [v, v ?? "[N/A]"])))),
      'role': () => firstValueFrom(of([["FullAccess", "Department Admin"], ["Admin", "Sys Admin"]]))
  };

  constructor(
    private usersService: UsersService, private groupsService: GroupsService, private groupMembersService: GroupMembersService, private effortService: EffortsService,
    private effortOwnersService: EffortOwnersService, private userService: UsersService, private deptService: GroupsService,
    private projectService: ProjectsService, private filterUtility: FilterChipUtilityService, private projectMembersService: ProjectMembersService,
    private dialog: MatDialog, private route: ActivatedRoute, private router: Router, private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.projSubscription?.unsubscribe();
    this.chosenColSubscr?.unsubscribe();
    this.colOrderSubscr?.unsubscribe();
    this.querySubscription?.unsubscribe();
    this.groupSubscription?.unsubscribe();
    this.effortSubscription?.unsubscribe();
    this.subscription?.unsubscribe();
    this.pageSubscr?.unsubscribe();
    this.groupMembersSubscription?.unsubscribe();
    this.projectMembersSubscription?.unsubscribe();
    this.effortOwnersSubscription?.unsubscribe();
    this.queryParamsSubscription?.unsubscribe();
  }

  ngAfterViewInit() {
    this.userService.getCurrentUser().subscribe(user => {
      this.currentUser = user;
      this.uiPreference = user.userUIPreference?.data ? JSON.parse(user.userUIPreference.data) : new UIPreference();
      const cols = this.uiPreference?.users?.displayedColumns ?? this.displayedColumns;
      const order = this.latestColumnOrder = this.uiPreference?.users?.columnOrder ?? cols;
      if (cols?.length) {
        const actualColumns = cols.filter(c => this.availableColumns.has(c));
        console.log(actualColumns, "actual column, sorting by", order);
        this.displayedColumns = [...actualColumns.sort(this.sortByOrder(order))];
        console.log(this.displayedColumns);
        this.chosenColumns.setValue(this.uiPreference?.users?.displayedColumns);
      }
      this.paginator.pageSize = this.uiPreference?.users?.pageSize ?? 10;
      // const roles = user.userRoles.map(ur => ur.role.roleName.toLowerCase());
    });
    this.querySubscription = combineLatest([
      this.dataChanged$.pipe(debounceTime(100)),
      this.sort.sortChange.pipe(startWith({ active: this.sort.active, direction: this.sort.direction })),
      this.paginator.page.pipe(startWith({ pageSize: this.paginator.pageSize, pageIndex: this.paginator.pageIndex })),
    ]).subscribe(([filters, sort, page]) => {
      this.subscription?.unsubscribe();
      this.subscription = this.usersService.filterUsers(filters, page.pageSize, page.pageIndex, sort.active, sort.direction).subscribe(resp => {
        this._loading.next(false);
        this.filters = filters;
        this.dataSource.data = resp.users;
        this.totalUsers = resp.total;
      });
    });
    this.groupMembersSubscription = this.groupMembersService.sourceUpdated$.subscribe(_ => this._dataChangedSubject.next(this.filters ?? []));
    this.projectMembersSubscription = this.projectMembersService.sourceUpdated$.subscribe(_ => this._dataChangedSubject.next(this.filters ?? []));
    this.effortOwnersSubscription = this.effortOwnersService.sourceUpdated$.subscribe(_ => this._dataChangedSubject.next(this.filters ?? []));
    this.queryParamsSubscription = this.route.queryParams.subscribe(p => {
      const filters = [];
      if (p["filter.effort.key"]) filters.push({ chip: 'effort.key', value: p["filter.effort.key"] });
      if (p["filter.effort"]) filters.push({ chip: 'effort', value: p["filter.effort"] });
      if (p["filter.project.key"]) filters.push({ chip: 'project.key', value: p["filter.project.key"] });
      if (p["filter.name"]) filters.push({ chip: 'name', value: p["filter.name"] });
      if (p["filter.email"]) filters.push({ chip: 'email', value: p["filter.email"] });
      if (p["filter.hawkid"]) filters.push({ chip: 'hawkid', value: p["filter.hawkid"] });
      if (p["filter.univid"]) filters.push({ chip: 'univid', value: p["filter.univid"] });
      if (p["filter.dept"]) filters.push({ chip: 'dept', value: p["filter.dept"] });
      if (p["filter.dept(owners)"]) filters.push({ chip: 'dept(owners)', value: p["filter.dept(owners)"] });
      if (p["filter.reportsto.hawkid"]) filters.push({ chip: "reportsto.hawkid", value: p["filter.reportsto.hawkid"] });
      if (p["filter.dept.key"]) filters.push({ chip: 'dept.key', value: p["filter.dept.key"] });
      if (p["filter.archived"]) filters.push(<FilterChip>{ chip: 'archived', isFlag: true, value: '1' });
      if (p["filter.deprovisioned"]) filters.push(<FilterChip>{ chip: 'deprovisioned', isFlag: true, value: '1' });
      if (p["filter.adsource"]) filters.push({ chip: 'adsource', value: p["filter.adsource"] });
      if (p["filter.hrsubdept"]) filters.push({ chip: 'hrsubdept', value: p["filter.hrsubdept"] });
      if (p["filter.hrdept"]) filters.push({ chip: 'hrdept', value: p["filter.hrdept"] });
      if (p["filter.orgid"]) filters.push({ chip: 'orgid', value: p["filter.orgid"] });
      if (p["filter.jobcode"]) filters.push({ chip: 'jobcode', value: p["filter.jobcode"] });
      if (p["filter.jobtitle"]) filters.push({ chip: 'jobtitle', value: p["filter.jobtitle"] });
      if (p["filter.paygrade"]) filters.push({ chip: 'paygrade', value: p["filter.paygrade"] });
      if (p["filter.role"]) filters.push({ chip: 'role', value: p["filter.role"] });

      if (p["filter.former.hrsubdept"]) filters.push({ chip: 'former.hrsubdept', value: p["filter.former.hrsubdept"] });
      if (p["filter.former.hrdept"]) filters.push({ chip: 'former.hrdept', value: p["filter.former.hrdept"] });
      if (p["filter.former.orgid"]) filters.push({ chip: 'former.orgid', value: p["filter.former.orgid"] });
      if (p["filter.former.jobcode"]) filters.push({ chip: 'former.jobcode', value: p["filter.former.jobcode"] });
      if (p["filter.former.jobtitle"]) filters.push({ chip: 'former.jobtitle', value: p["filter.former.jobtitle"] });
      if (p["filter.former.paygrade"]) filters.push({ chip: 'former.paygrade', value: p["filter.former.paygrade"] });

      // if (p["filter.effort.key"]) filters.push({ chip: 'effort.key', value: p["filter.effort.key"] });
      if (p["filter.keywords"]) filters.push({ chip: null, value: p["filter.keywords"] });
      this.paginator.firstPage();
      this.filters = filters;
      this.selectedFilters.next(filters);
      this.cdr.detectChanges();
      this._dataChangedSubject.next(filters);
    }
    );
    this.pageSubscr = this.paginator.page
      .pipe(map(ev => ev.pageSize), distinct())
      .subscribe(size => {
        if (!this.uiPreference) return;

        this.uiPreference!.users ??= new UserManagementPreferences();
        this.uiPreference.users.pageSize = size;
        this.userService.savePreference(this.uiPreference!, this.currentUser!.id).subscribe(uipref => {
          console.info("Saved pageSize preference.");
        });
      });
    this.colOrderSubscr = this.columnOrderChanges
      .pipe(distinct())
      .subscribe(order => {
        if (!this.uiPreference) return;

          this.uiPreference!.users ??= new UserManagementPreferences();
          this.uiPreference!.users.columnOrder = order;
          // this.uiPreference!.efforts.columnOrder = <any>undefined;
          this.userService.savePreference(this.uiPreference!, this.currentUser!.id).subscribe(uipref => {
              console.info("Saved col order preference.", order);
          });
      });
    this.chosenColSubscr = this.chosenColumns.valueChanges
      .pipe(distinct(), debounceTime(40))
      .subscribe((v) => {
        this.displayedColumns = [...v.sort(this.sortByOrder(this.latestColumnOrder ?? v))];
        if (!this.uiPreference) return;

          this.uiPreference!.users ??= new UserManagementPreferences();
          this.uiPreference!.users.displayedColumns = v;
          // this.uiPreference!.efforts.displayedColumns = <any>undefined;
          this.userService.savePreference(this.uiPreference!, this.currentUser!.id).subscribe(uipref => {
              console.info("Saved displayedColumns preference.", v);
          });
      });
  }

  reorderColumns($event: CdkDragDrop<string[]>) {
    moveItemInArray(this.displayedColumns, $event.previousIndex, $event.currentIndex);
    // console.log(this.reorderColumns.name, this.displayedColumns);
    const fullOrder = [...this.availableColumns.keys()].sort(this.sortByOrder([...this.displayedColumns]));
    this.columnOrderChanges$.next(fullOrder);
  }

  resetColumns() {
    console.log("Resetting");
    this.chosenColumns.setValue(this.defaultColumns);
    this.columnOrderChanges$.next([]);
  }

  hideColumn($event: CdkDragDrop<string[]>) {
    console.log("hiding", $event.previousIndex, this.displayedColumns[$event.previousIndex]);
    const item = this.displayedColumns[$event.previousIndex];
    const cur: string[] = this.chosenColumns.value || [];
    this.chosenColumns.setValue(cur.filter(c => c !== item));
  }

  sortByOrder(order: string[]) {
    if (! order?.length) return () => 0;
    return (a: string, b: string) => {
        const ai = order.indexOf(a);
        const bi = order.indexOf(b);
        return ai < bi ? -1 : (ai > bi ? 1 : 0);
    }
  }

  clearFilter(which: string) { this.selectedFilters.next(this.filters?.filter(f => f.chip !== which) ?? []); return false; }

  openEditDialog(user: User): void {
    const dialogRef = this.dialog.open(UserEditorComponent, { data: { user }, width: '50vw', minWidth: '500px', maxWidth: '720px' });
    dialogRef.afterClosed().subscribe(result => {
      if (result && !result.isNew) {
        console.log("Saving updated user", result);
        user.reportsToId = result.reportsTo?.id;
        user.excludeFromLeaveExport = result.user.excludeFromLeaveExport;
        user.userRoles = result.user.userRoles;
        user.isDeleted = result.user.isDeleted;
        user.subdeptCode = result.user.subdeptCode;
        user.tksBeginDate = result.user.tksBeginDate;
        console.log("Setting TKS Begin Date to", user.tksBeginDate);
        user.includeForFinalLeave = result.user.includeForFinalLeave;
        this.usersService.updateUser(user).subscribe(() => this._dataChangedSubject.next(this.filters ?? []));
      }
    });
  }

  openBatchEditDialog(user: User): void {
    const dialogRef = this.dialog.open(BatchAddRemoveFromUsersComponent, { data: { user }, minWidth: '40em', maxWidth: '100vw' });
    dialogRef.afterClosed().subscribe(result => {
      console.log("Saving changes", result);
    });
  }

  roleDescription(roleId: number) {
    switch (roleId) {
      case 1: return "System Admin";
      case 2: return "Department Admin";
      default: return "User"
    }
  }

  async openAddUsersDialog(which: string): Promise<void> {
    let title: string;
    if (this.group) {
      title = "Add owners to department '" + this.group.name + "'";
    } else if (this.project) {
      title = "Add users to project '" + this.project.title + "'";
    } else if (this.effort) {
      title = "Add owners to effort '" + this.effort.title + "'";
    } else {
      console.error("Shouldn't be able to get here without a group, effort, or project.");
      return;
    }

    this.dialog.open(GroupMembershipEditorComponent, {
      width: '50vw', minWidth: '500px', maxWidth: '720px',
      data: { title }
    }).afterClosed().subscribe(async members => {
      if (members?.length) {
        console.info(this.openAddUsersDialog.name, 'Updated Group:', members);
        if (which == 'group')
          this.groupMembersService.addGroupMemberships(this.group!, members);
        else if (which == 'project')
          this.projectMembersService.addProjectMemberships(this.project!, members);
        else if (which == 'effort')
          this.effortOwnersService.addEffortOwners(this.effort!, members);
      }
    });
  }

  removeUserFromGroup(user: User, group: Group) {
    console.info(this.removeUserFromGroup.name);
    const data = { message: `Remove user '${user.displayName}' from group '${group.name}'?` };
    this.dialog.open(ConfirmComponent, { data }).afterClosed()
      .subscribe(yes => {
        if (yes) this.groupMembersService.deleteGroupMembership(group.id, user.id);
      })
  }

  removeUserFromProject(user: User, project: Project) {
    console.info(this.removeUserFromProject.name);
    const data = { message: `Remove user '${user.displayName}' from project '${project.title}'?` };
    this.dialog.open(ConfirmComponent, { data }).afterClosed()
      .subscribe(yes => {
        if (yes && project.id) this.projectMembersService.deleteProjectMembership(project.id, user.id);
      })
  }

  removeUserFromEffort(user: User, effort: Effort) {
    console.info(this.removeUserFromEffort.name);
    const data = { message: `Remove user '${user.displayName}' from effort '${effort.title}'?` };
    this.dialog.open(ConfirmComponent, { data }).afterClosed()
      .subscribe(yes => {
        if (yes && effort.id) this.effortOwnersService.deleteEffortOwner(effort.id, user.id);
      })
  }

  filterChange(filters: FilterChip[]): void {
    console.log("Filter changed", filters);
    this._loading.next(true);
    this.filterUtility.updateUrlWithFilters(filters, 'users');

    const clear = (col: string) => {
      this.displayedColumns = this.displayedColumns.filter(dc => dc != col);
    }
    const add = (col: string) => {
      this.displayedColumns = this.displayedColumns.find(ac => ac == col) ? this.displayedColumns : [...this.displayedColumns, col]
    }
    const gstCol = "group-specific-tools";
    const groupFilter = filters.find(f => f.chip == "dept.key");
    if (groupFilter) {
      this.groupSubscription?.unsubscribe();
      this.groupSubscription = this.groupsService.filterGroups([{ chip: 'key', value: groupFilter.value }]).subscribe(res => {
        if (res.total == 1) {
          this.group = res.groups[0];
          //this.displayedColumns = this.displayedColumns.find(ac => ac == gstCol) ? this.displayedColumns : [...this.displayedColumns, gstCol]
          add(gstCol);
        } else {
          console.warn("More than one group with this key.");
          this.group = undefined;
          clear(gstCol);
        }
      });
    } else {
      this.group = undefined;
      clear(gstCol);
    }

    const projectFilter = filters.find(f => f.chip == "project.key");
    const pstCol = "project-specific-tools";
    if (projectFilter) {
      if (this.projSubscription) this.projSubscription.unsubscribe();
      this.projSubscription = this.projectService.filterProjects([{ chip: 'key', value: projectFilter.value }]).subscribe(res => {
        console.log(res);
        if (res.total == 1) {
          this.project = res.projects[0];
          add(pstCol);
        } else {
          this.project = undefined;
          clear(pstCol);
        }
      })
    } else {
      this.project = undefined;
      clear(pstCol);
    }

    const effortFilter = filters.find(f => f.chip == "effort.key");
    const estCol = "effort-specific-tools";
    if (effortFilter) {
      if (this.effortSubscription) this.effortSubscription.unsubscribe();
      this.effortSubscription = this.effortService.filterEfforts([{ chip: 'key', value: effortFilter.value }]).subscribe(res => {
        console.log(res);
        if (res.total == 1) {
          this.effort = res.efforts[0];
          add(estCol);
        } else {
          this.effort = undefined;
          clear(estCol);
        }
      })
    } else {
      this.effort = undefined;
      clear(estCol);
    }
    this._dataChangedSubject.next(filters);
  }
}
